import { render, staticRenderFns } from "./UiAgree.vue?vue&type=template&id=7d328f18&scoped=true&lang=pug"
import script from "./UiAgree.vue?vue&type=script&lang=js"
export * from "./UiAgree.vue?vue&type=script&lang=js"
import style0 from "./UiAgree.vue?vue&type=style&index=0&id=7d328f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d328f18",
  null
  
)

export default component.exports